import { useFormContext } from 'react-hook-form';
import { SelectComponent } from '../../../../components/Form/Select';

export function Origem() {
  const {
    control,
    formState: { errors }
  } = useFormContext();

  return (
    <SelectComponent
      width="100%"
      label="Origem"
      control={control}
      name="origin"
      options={[
        { value: '1', label: 'Prospecção' },
        { value: '2', label: 'Google' },
        { value: '3', label: 'Bríndice' },
        { value: '7', label: 'Indicação' },
        { value: '8', label: 'Email Marketing' },
        { value: '9', label: 'Facebook' },
        { value: '10', label: 'Linkedin' },
        { value: '17', label: 'Loja Contrato' },
        { value: '18', label: 'Instagram' }
      ]}
      error={errors.origin}
    />
  );
}
